// 5.46.0 personal info for quoting — pure helpers (tested in hsPersonal.test.mjs).

// Whole years on a given day (ISO dates 'YYYY-MM-DD'); null when either is missing or invalid.
export function ageOn(dobIso, onIso) {
  const m1 = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(dobIso || ''));
  const m2 = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(onIso || ''));
  if (!m1 || !m2) return null;
  const [y1, mo1, d1] = m1.slice(1).map(Number);
  const [y2, mo2, d2] = m2.slice(1).map(Number);
  let a = y2 - y1;
  if (mo2 < mo1 || (mo2 === mo1 && d2 < d1)) a -= 1;
  return a >= 0 ? a : null;
}

export const ageOnJan1 = (dobIso, planYear) => ageOn(dobIso, `${planYear}-01-01`);

export function fmtDob(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
  return m ? `${m[2]}/${m[3]}/${m[1]}` : '';
}

export const REL_LABEL = { primary: 'Primary', spouse: 'Spouse', dependent: 'Dependent' };
export const tobaccoLabel = (v) => (v === true ? 'Tobacco user' : v === false ? 'No tobacco' : '—');
export const genderLabel = (v) => (v ? v.charAt(0).toUpperCase() + v.slice(1) : '—');
